"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingReview = void 0;
var account_1 = require("../account");
var content_1 = require("../content");
/**
 * @deprecated
 * use new implementation @see './review'
 */
var MeetingReview = /** @class */function () {
  function MeetingReview(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'meeting_id', 'author_id', 'reporter_id', 'is_rated', 'comment', 'message', 'feedback', 'auto_comment', 'rating_author', 'rating_qos', 'rating_uix', 'rated_at'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('meeting' in values) {
      instance.meeting = new content_1.Meeting(values.meeting);
    }
    if ('author' in values) {
      instance.author = new account_1.User(values.author);
    }
    if ('reporter' in values) {
      instance.reporter = new account_1.User(values.reporter);
    }
  }
  return MeetingReview;
}();
exports.MeetingReview = MeetingReview;
